import { createSlice } from '@reduxjs/toolkit'

export const userProfileSlice = createSlice({
    name: 'userProfile',
    initialState: {
        value: undefined
    },
    reducers: {
        set: (state, action) => {
            state.value = action.payload;
        },
        unSet: state => {
            state.value = undefined;
        }
    }
})

// Action creators are generated for each case reducer function
export const { set, unSet } = userProfileSlice.actions

export default userProfileSlice.reducer